import React from 'react';
import { Card, CardContent, makeStyles, Typography } from '@material-ui/core';
import { pxToRem } from '@fluentsms/agentnet-web-components';

interface SectionCardProps {
  title: string;
  headerRight?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const useStyles = makeStyles((theme) => ({
  card: {
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none',
    borderRadius: 4,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  title: {
    fontSize: pxToRem(16),
    fontWeight: 600,
  },
  content: {
    padding: theme.spacing(3),
  },
}));

const SectionCard: React.FC<SectionCardProps> = ({ title, headerRight, children, className }) => {
  const classes = useStyles();

  return (
    <Card className={`${classes.card} ${className ?? ''}`}>
      <div className={classes.header}>
        <Typography className={classes.title}>{title}</Typography>
        {headerRight && <div>{headerRight}</div>}
      </div>
      <CardContent className={classes.content}>{children}</CardContent>
    </Card>
  );
};

export default SectionCard;
